/**
 * @file index.js
 * @author 郑亦馨
 * @desc 法律-北大法宝外链
 */
import store from '@/store/index';
// 北大法宝工具
export const pkuLaw = 'https://login.pkulaw.com/account/BaiDuLvLinGroupLogin';

// 转换北大法宝链接，附加用户名手机号等登录信息
export function transBDFBUrl(options) {
    const {menu, redirectUrl} = options;
    const {uk, lawyer_info, user_role, law_business_info} = store.state.lawStore?.userInfoNew || {};
    let info = +user_role === 2 ? law_business_info : lawyer_info;
    let {sign, phone_number} = info || {};
    const phone = encodeURIComponent(phone_number);
    let url = `${pkuLaw}?groupUserName=百度知道律临&sign=${sign}&loginName=LV_${uk}&phoneNumber=${phone}`;
    if (menu) {
        url += `&menu=${menu}`;
    }
    if (redirectUrl) {
        url += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;
    }
    return url;
}
